import { Button, Link, Space, Text } from '@billy/design-system'
import { useCallback } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { useSkatConnection } from '@features/vatDeclarations/contexts/skatConnectionContext'
import { IntegrationFormFlow } from '@features/vatDeclarations/enums/integrationFormFlow'
import { SkatIntegrationStatus } from '@features/vatDeclarations/enums/skatIntegrationStatus'

import { useSegment } from '../../../../../../hooks'
import { Steps } from '../Steps'

interface InstructionsPageProps {
  handleCancelClick: () => void
}

export const InstructionsPage = ({ handleCancelClick }: InstructionsPageProps) => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { updateSkatConnection, connectionState, setConnectionState } = useSkatConnection()
  const isLoading =
    connectionState === SkatIntegrationStatus.Redirecting || connectionState === SkatIntegrationStatus.Connecting

  const handleConnectClick = useCallback(() => {
    track('xxx - Bookkeeping - DK VAT integration', {
      flow: IntegrationFormFlow.Connect,
      step: '1 - How to',
      buttonClick: 'Start connection',
    })
    setConnectionState(SkatIntegrationStatus.Redirecting)
    setTimeout(() => {
      setConnectionState(SkatIntegrationStatus.Connecting)
      updateSkatConnection(IntegrationFormFlow.Connect)
    }, 1000)
  }, [setConnectionState, updateSkatConnection, track])

  const buttonCopy = {
    [SkatIntegrationStatus.Connecting]: t('skat_form.connecting'),
    [SkatIntegrationStatus.Redirecting]: t('skat_form.redirecting'),
    [SkatIntegrationStatus.Idle]: t('skat_form.start_connection'),
  }

  return (
    <>
      <Text variant="h1">{t('skat_form.instructions.header')}</Text>
      <Space size="s8" />
      <Text>
        <Trans i18nKey="skat_form.instructions.description">
          Once you start the connection you will be transferred to SKAT. There you can follow the three steps below to
          grant us access. You can also watch our video guide
          <Link
            target="_blank"
            underlined
            href="https://help.shine.co/da/articles/625998-sadan-indberetter-du-moms-til-skat-via-shine-regnskab"
          >
            here
          </Link>
          .
        </Trans>
      </Text>
      <Space size="s24" />
      <Steps />
      <Space size="s24" />
      <Button icon="squareArrowOutUpRight" fullWidth onClick={handleConnectClick} loading={isLoading}>
        {buttonCopy[connectionState]}
      </Button>
      <Space size="s8" />
      <Button variant="text" fullWidth onClick={handleCancelClick}>
        {t('cancel')}
      </Button>
    </>
  )
}
